import { ReactElement } from 'react';
import { TitleBlock, TitleText, SubTitleText } from './Title.style';

const Title = (): ReactElement => {
  return (
    <TitleBlock>
      <TitleText>AI議事録チェッカー</TitleText>
      <SubTitleText>会議録音管理システム</SubTitleText>
    </TitleBlock>
  );
};

export default Title;
